import { Component, Vue, PropSync, Emit, Watch } from 'vue-property-decorator';
import { TableFilterField } from '@/models/tables/TableFilterField';
import { ApiIdentifers } from '@/config/index';
import { TableDataSet } from '@/models/tableDataset/TableDataSet';
import { TableDataSetSection } from '@/models/tableDataset/TableDataSetSection';
import { TableDataSetField } from '@/models/tableDataset/TableDataSetField';
import { TableClickEvent } from '@/models/tables/TableClickEvent';
import { LoggerService } from '@/utils';
import { DataSet } from '@/models/dataset/DataSet';
import { DataSetField } from '@/models/dataset/DataSetField';
import { DataSetSection } from '@/models/dataset/DataSetSection';
import { Helpers } from '../../../helpers/Helpers';

@Component
export default class TableItemFrontComponent extends Vue {
    @PropSync('dataSet', { type: Object }) public syncedDataSet!: DataSet;
    @PropSync('tableDataSet', { type: Object }) public syncedTableDataSet!: TableDataSet;
    @PropSync('section', { type: String }) public syncedSection!: string;
    @PropSync('subSections', { type: Array }) public syncedSubSections!: number[];
    @PropSync('fixedFields', { type: Object }) public syncedFixedFields!: TableFilterField;
    @PropSync('listRef', { type: Object }) public syncedListRef!: Vue;
    @PropSync('selectedId', { type: String }) public syncedSelectedId!: string;

    @PropSync('fixed', { type: Boolean }) public syncedFixed!: boolean;

    public frontFields: TableDataSetSection = new TableDataSetSection();
    public selectedSection: TableDataSetSection = new TableDataSetSection();

    public identifers: any = ApiIdentifers;
    public selected: boolean = false;
    public itemCounter: number = 0;
    public showItemCounter: boolean = false;
    public showUnsyncedMarker: boolean = false;

    public selectedDataFields?: DataSetField[] = [];
    public selectedDataSection?: DataSetSection;

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.setData();
    }

    public updated() {
        this.checkMaterialCount();
    }

    @Watch('syncedDataSet', { deep: true })
    public onSyncedDataSetChanged(newValue: TableDataSet) {
        // LoggerService.LogDebug(`TableItemFrontComponent onSyncedTableDataSetChanged: `, newValue);
        this.setData();
    }

    @Watch('syncedSelectedId')
    public onSyncedSelectedIdChanged(newValue: string) {
        // LoggerService.LogDebug(`onSyncedSelectedIdChanged: ${newValue}`, this.syncedTableDataSet.dataSetId);
        this.selected = this.syncedDataSet.dataSetId === this.syncedSelectedId;
    }

    @Watch('syncedSection')
    public onSyncedSectionChanged(newValue: string) {
        // LoggerService.LogDebug(`onSyncedSectionChanged: ${newValue}`);
        this.selectedSection = this.syncedTableDataSet.sections.find((sec) => sec.identifier === this.syncedSection) || new TableDataSetSection();
        this.checkMaterialCount();
    }

    @Emit('itemClicked')
    public emitItemClicked(event: TableClickEvent) {
        return event;
    }

    @Emit('itemDbClicked')
    public emitItemDbClicked(dataSetId: string) {
        return dataSetId;
    }

    public GetFrontField(identifier?: string): string {
        const dataField = this.selectedDataFields && this.selectedDataFields.find((f) => f.identifier === identifier);
        let value = '-';

        if (dataField !== undefined) {
            value = dataField.valueString || '-';
            if (identifier === ApiIdentifers.generalTrialDate && value !== '-') {
                value = Helpers.getFormattedDateString(value);
            }
        } else if (identifier === 'tabId') {
            // for tabId
            value = this.syncedDataSet.dataSetId ? this.syncedDataSet.dataSetId : '-';
        }
        return value;
    }

    public onItemClicked(event: MouseEvent) {
        const element = event.currentTarget as HTMLDivElement;
        /**
         * calculate position where the row menu should be shown
         */
        this.emitItemClicked(new TableClickEvent(
            {
                dataSetId: this.syncedDataSet.dataSetId || '',
                positionX: element.offsetLeft + (element.offsetWidth / 2),
                positionY: element.offsetTop - this.syncedListRef.$el.scrollTop + (element.offsetHeight / 2),
                isFixed: false,
            }));
    }

    public onItemDbCLicked(event: MouseEvent) {
        this.emitItemDbClicked(this.syncedDataSet.dataSetId || '');
    }

    public checkMaterialCount() {
        if (this.selectedSection && this.selectedSection.action !== undefined) {
            if (this.syncedDataSet.actionItems !== undefined) {
                const counterData = this.syncedDataSet.actionItems.find((ai) => ai.identifier === this.syncedSection);
                if (counterData !== undefined) {
                    this.itemCounter = counterData.fieldCount;
                } else {
                    this.itemCounter = 0;
                }
            } else {
                this.itemCounter = 0;
            }
            this.showItemCounter = true;
        } else {
            this.itemCounter = 0;
            this.showItemCounter = false;
        }
    }

    public getHidden(): boolean {
        return this.syncedFixed === false && this.syncedDataSet.fixedRow === true;
    }

    private setData() {
        if (this.syncedTableDataSet) {
            this.frontFields = this.syncedTableDataSet.sections.find((sec) => sec.identifier === ApiIdentifers.general) || new TableDataSetSection();
            this.selectedSection = this.syncedTableDataSet.sections.find((sec) => sec.identifier === this.syncedSection) || new TableDataSetSection();
        }
        if (this.syncedDataSet) {
            this.selectedDataSection = this.syncedDataSet.sections.find((sec) => sec.identifier === this.syncedSection);
            const data = this.syncedDataSet.sections.find((sec) => sec.identifier === ApiIdentifers.general);
            if (data !== undefined) {
                this.selectedDataFields = data.fields;
            }
            this.showUnsyncedMarker = this.syncedDataSet.unsyncedParts === true;
        }
    }
}
